<template>
  <div class="bdp" :class="{'bdp--horizontal': horizontal}">
    <div class="bdp__flow">
      <template v-for="(stage, i) in stages">
        <div
          :key="stage.key"
          class="bdp__card"
          :class="'bdp__card--' + stage.key"
          @click="goRoute(stage.route)"
        >
          <div class="bdp__glow" />
          <div class="bdp__icon">
            <BaseIcon :icon="stage.icon" :size="iconSize" color="#fff" />
          </div>
          <div class="bdp__name">{{ stage.name }}</div>
          <div class="bdp__count">{{ stage.count }}<small>项</small></div>
          <div class="bdp__amount">{{ formatAmount(stage.amount) }}</div>
        </div>

        <div v-if="i < stages.length - 1" :key="'link-' + i" class="bdp__bridge">
          <span v-if="stages[i + 1].convert_rate" class="bdp__rate">{{ stages[i + 1].convert_rate }}%</span>
          <svg class="bdp__arrow" viewBox="0 0 20 12" aria-hidden="true">
            <path d="M0 6h14M10 2l5 4-5 4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {USE_MOCK, formatAmount, mockPipeline} from './bid-dashboard-mock';

export default {
  props: {
    data: {type: Object, default: () => ({horizontal: true})},
  },
  data() {
    return {stages: []};
  },
  computed: {
    horizontal() {
      return this.data.horizontal !== false;
    },
    iconSize() {
      return this.horizontal ? 18 : 16;
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    formatAmount,
    loadData() {
      if (USE_MOCK) {
        this.stages = mockPipeline().stages;
        return;
      }
      this.$api.get('/business/bid/dashboard/pipeline').then((res) => {
        this.stages = (res.data.data || {}).stages || [];
      }).catch(() => {
        this.stages = mockPipeline().stages;
      });
    },
    goRoute(route) {
      const base = this.$route.path.replace(/\/[^/]+$/, '');
      this.RouteTo(`${base}/${route}`);
    },
  },
};
</script>

<style lang="less" scoped>
.bdp {
  height: 100%;
  display: flex;
  padding: 6px 8px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #c5ddf5;
  overflow: hidden;
  box-sizing: border-box;
}

.bdp__flow {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  gap: 0;
  min-height: 0;
  min-width: 0;
}

.bdp__card {
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  height: 100%;
  padding: 6px 8px;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  transition: transform 0.15s;

  &--info {
    background: linear-gradient(145deg, #0d4a8f, #1a6fd4);
    box-shadow: 0 2px 8px rgba(26, 111, 212, 0.25);
  }

  &--work {
    background: linear-gradient(145deg, #1e40af, #3b82f6);
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);
  }

  &--open {
    background: linear-gradient(145deg, #b45309, #d97706);
    box-shadow: 0 2px 8px rgba(217, 119, 6, 0.25);
  }

  &:hover { transform: translateY(-1px); }
}

.bdp__glow {
  position: absolute;
  top: -16px;
  right: -16px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  pointer-events: none;
}

.bdp__icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.bdp__name {
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  margin-top: 4px;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.bdp__count {
  font-size: 17px;
  font-weight: 800;
  color: #fff;
  margin-top: 2px;
  line-height: 1.1;

  small {
    font-size: 10px;
    font-weight: 500;
    opacity: 0.85;
    margin-left: 1px;
  }
}

.bdp__amount {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
  line-height: 1.2;
  margin-top: 2px;
}

.bdp__bridge {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 32px;
  flex-shrink: 0;
  color: #9cb8d8;
}

.bdp__rate {
  font-size: 9px;
  font-weight: 800;
  color: #d97706;
  background: #fffbeb;
  padding: 0 4px;
  border-radius: 6px;
  border: 1px solid #fde68a;
  margin-bottom: 2px;
  line-height: 1.4;
}

.bdp__arrow {
  width: 18px;
  height: 9px;
}

.bdp:not(.bdp--horizontal) {
  .bdp__flow {
    flex-direction: column;
    gap: 4px;
  }

  .bdp__card {
    width: 100%;
    height: auto;
    flex: 1;
    flex-direction: row;
    text-align: left;
    gap: 8px;
    padding: 6px 10px;
  }

  .bdp__icon { margin: 0; width: 28px; height: 28px; }
  .bdp__name { flex: 1; margin-top: 0; }
  .bdp__count, .bdp__amount { flex-shrink: 0; margin-top: 0; }

  .bdp__bridge {
    flex-direction: row;
    width: auto;
    height: 12px;
    padding-left: 14px;
  }
}
</style>
